import { __assign, __awaiter, __generator } from "tslib";
import { supportConvertedExtRegExp, supportTypeMap } from '../constant/file-type-check';
import { DrivePadType, } from '../entity/file-meta.interface';
var FileMetaEntity /* extends Entity */ = /** @class */ (function () {
    function FileMetaEntity(fileMetaRepo) {
        this.fileMetaRepo = fileMetaRepo;
    }
    /**
     * @deprecated 之前因为 FileInfoDomainService.init 代码异常 FileMetaEntity.init 没有成功调用，所以有些地方主动调用了 init 方法，不再建议调用
     * 更新 this 上的静态字段
     */
    FileMetaEntity.prototype.init = function (data) {
        Object.assign(this, data);
    };
    /**
     * 通过 fileInfo cgi 更新 this 上的静态字段
     */
    FileMetaEntity.prototype.initWithFileInfoRsp = function (result) {
        var mimeType = result.mimeType, fileMeta = result.fileMeta;
        Object.assign(this, __assign(__assign({}, fileMeta), { mimeType: mimeType, icon: fileMeta.iconUrl }));
    };
    FileMetaEntity.prototype.fetchPreviewInfo = function () {
        return __awaiter(this, arguments, void 0, function (options) {
            if (options === void 0) { options = {}; }
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fileMetaRepo.fetchPreviewInfo({
                        fileId: this.fileId,
                        addBrowseRecord: (options === null || options === void 0 ? void 0 : options.addBrowseRecord) || false,
                        previewAttribute: __assign({ srcType: this.ext }, options.previewAttribute),
                    })];
            });
        });
    };
    /**
     * 查询文件预览信息
     */
    FileMetaEntity.prototype.fetchPreviewQuery = function (shouldRetry) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fileMetaRepo.fetchPreviewQuery({
                        fileId: this.fileId,
                        shouldRetry: shouldRetry,
                    })];
            });
        });
    };
    FileMetaEntity.prototype.fetchDownloadInfo = function (docId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fileMetaRepo.fetchDownloadInfo(docId)];
            });
        });
    };
    FileMetaEntity.prototype.fetchCopyInfo = function (docId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fileMetaRepo.fetchCopyInfo(docId)];
            });
        });
    };
    FileMetaEntity.prototype.getDrivePadType = function () {
        var cosInfo = this.cosInfo;
        var keys = Object.keys(supportTypeMap);
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            var value = supportTypeMap[key]; // 增加图音视频type
            if (!(cosInfo === null || cosInfo === void 0 ? void 0 : cosInfo.driveExt) || !value.test(cosInfo.driveExt)) {
                continue;
            }
            return key;
        }
        return DrivePadType.DOC;
    };
    FileMetaEntity.prototype.canBeConvertedToOnlineDocs = function () {
        var ext = this.ext;
        return supportConvertedExtRegExp.test(ext);
    };
    FileMetaEntity.prototype.getFormattedFileSize = function () {
        var size = this.size;
        // size 可能是 '0'
        if (Number(size) === 0)
            return '0 B';
        var standard = 1024;
        var units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        var i = Math.floor(Math.log(size) / Math.log(standard));
        return "".concat(parseFloat((size / Math.pow(standard, i)).toPrecision(3)), " ").concat(units[i]);
    };
    return FileMetaEntity;
}());
export { FileMetaEntity };
